// Loading skeletons that mirror each tab's final layout proportions.
type Variant = 'marks' | 'table' | 'chart' | 'time';

function Bar({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded bg-slate-200 ${className}`} />;
}

export function ReportSkeleton({ variant }: { variant: Variant }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Bar className="h-5 w-40" />
        <Bar className="h-6 w-24 rounded-full" />
      </div>

      {variant === 'marks' && (
        <>
          <Bar className="h-8 w-56" />
          <div className="grid grid-cols-3 gap-2">
            <Bar className="h-24 rounded-2xl" />
            <Bar className="h-24 rounded-2xl" />
            <Bar className="h-24 rounded-2xl" />
          </div>
          <Bar className="h-2.5 w-full" />
          <Bar className="h-2.5 w-5/6" />
          <Bar className="h-16 w-full rounded-2xl" />
        </>
      )}

      {variant === 'table' &&
        [0, 1, 2, 3, 4].map((i) => <Bar key={i} className="h-12 w-full rounded-xl" />)}

      {variant === 'chart' && (
        <div className="flex gap-4">
          <Bar className="h-64 flex-1 rounded-2xl" />
          <div className="hidden w-48 space-y-2 sm:block">
            <Bar className="h-20 rounded-2xl" />
            <Bar className="h-20 rounded-2xl" />
            <Bar className="h-20 rounded-2xl" />
          </div>
        </div>
      )}

      {variant === 'time' && (
        <>
          <Bar className="mx-auto h-52 w-52 rounded-full" />
          <Bar className="h-10 w-full rounded-xl" />
          <Bar className="h-10 w-full rounded-xl" />
        </>
      )}
    </div>
  );
}
